import { RadioButton, RadioGroup } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { pitchMarkerColouringModeAtom } from '@/atoms/visualisation';
import { useSetQueryParams } from '@/hooks/queryParams/useSetQueryParams';
import { ConfigDisplaySettingKey } from '@/types/userConfigs';

export const PitchMarkerColouring = () => {
  const { t } = useTranslation('visualisation');

  const pitchMarkerColouringMode = useAtomValue(pitchMarkerColouringModeAtom);
  const setQueryParams = useSetQueryParams();

  return (
    <RadioGroup groupId="pitch-marker-colouring" groupTitle={t('markerColouring.title')} size="regular">
      <RadioButton
        checked={pitchMarkerColouringMode === 'default'}
        onChange={() => setQueryParams(ConfigDisplaySettingKey.PITCH_MARKER_COLOURING_MODE, 'default')}
        id="marker-colours-default-option"
        label={t('markerColouring.default')}
        value="false"
        size="small"
      />
      <RadioButton
        checked={pitchMarkerColouringMode === 'passSuccess'}
        onChange={() => setQueryParams(ConfigDisplaySettingKey.PITCH_MARKER_COLOURING_MODE, 'passSuccess')}
        id="marker-colours-pass-success-option"
        label={t('markerColouring.passSuccess')}
        value="false"
        size="small"
      />
      <RadioButton
        checked={pitchMarkerColouringMode === 'xg'}
        onChange={() => setQueryParams(ConfigDisplaySettingKey.PITCH_MARKER_COLOURING_MODE, 'xg')}
        id="marker-colours-xg-option"
        label={t('markerColouring.xg')}
        value="false"
        size="small"
      />
      <RadioButton
        checked={pitchMarkerColouringMode === 'obv'}
        onChange={() => setQueryParams(ConfigDisplaySettingKey.PITCH_MARKER_COLOURING_MODE, 'obv')}
        id="marker-colours-obv-option"
        label={t('markerColouring.obv')}
        value="false"
        size="small"
      />
    </RadioGroup>
  );
};
